import AbstractRequestTask from '../AbstractRequestTask';

class netTask extends AbstractRequestTask {

  constructor(params) {
    super();
    this.params = params;
  }

  getUrl() {
    const urlDominioMicrofwk = window.getConfig.url_dominio_microfwk;
    return `${urlDominioMicrofwk}services/user/net/request`;
  }

  getParams() {
    const params = super.getParams();
    this.params = Object.assign(params, this.params);
    
    return params;
  }

  success(data, b) {
    const isValid = super.success(data, b);
    if (!isValid) {
      return this.reject(data, b);
    }
    return this.resolve(data);
  }
}

export default netTask;
